// extracted by mini-css-extract-plugin
module.exports = {"RoundContainer":"BHRound_RoundContainer__E3wvK","Canvas":"BHRound_Canvas__3EVhL","noSelect":"BHRound_noSelect__iANsi","textBox":"BHRound_textBox__3ZWvd"};